module.exports = __webpack_public_path__ + "static/media/preview_black_24dp.e2bc61b7.svg";